import { render, staticRenderFns } from "./ProductConfiguratorColor.vue?vue&type=template&id=691a0dd6&scoped=true&"
import script from "./ProductConfiguratorColor.vue?vue&type=script&lang=js&"
export * from "./ProductConfiguratorColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a0dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691a0dd6')) {
      api.createRecord('691a0dd6', component.options)
    } else {
      api.reload('691a0dd6', component.options)
    }
    module.hot.accept("./ProductConfiguratorColor.vue?vue&type=template&id=691a0dd6&scoped=true&", function () {
      api.rerender('691a0dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductConfiguratorColor.vue"
export default component.exports